
import { reasons } from './review.js';

export default {
  props: {
    form: {
      type: Object,
      required: true
    },
    // 审核表单
    // 非批量需要展示审核意见、tracking_link
    // 批量处理只需要展示拒绝理由
    isBatch: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    schema: function schema() {
      return {
        type: 'object',
        properties: {
          adv_tracking_link: {
            visible: !!this.form.adv_tracking_link,
            title: 'Landing Page：',
            component: 'link'
          },
          review_opinion: {
            title: '请选择审核意见：',
            component: 'radio-group',
            field: {
              options: [{
                label: '通过',
                value: 3
              }, {
                label: '拒绝，不通过',
                value: 2
              }]
            }
          },
          reason_ids: {
            visible: this.form.review_opinion === 2,
            title: '拒绝原因：',
            component: 'checkbox-group',
            field: {
              options: reasons.filter(function (item) {
                return item.value !== 7 && item.value !== 4;
              })
            }
          },
          reason_text: {
            visible: this.form.reason_ids.some(function (item) {
              return item === 99;
            }),
            title: '其他拒绝原因：',
            component: 'input',
            field: {
              type: 'textarea',
              maxlength: 500
            }
          }
        }
      };
    },
    rules: function rules() {
      return {
        review_opinion: [{
          required: true,
          trigger: 'change'
        }],
        ad_rule_text: [{
          required: this.form.reason_ids.some(function (item) {
            return item === 8;
          }),
          message: '请填写违规原因',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '长度在 1 到 500 个字符',
          trigger: 'blur'
        }],
        reason_ids: [{
          required: true,
          type: 'array',
          message: '请选择至少一个拒绝原因',
          trigger: 'change'
        }],
        reason_text: [{
          required: true,
          message: '请填写其他拒绝原因',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '长度在 1 到 500 个字符',
          trigger: 'blur'
        }]
      };
    }
  },
  watch: {
    'form.reason_ids': function formReason_ids(val) {
      if (!val.some(function (item) {
        return item === 99;
      })) {
        // eslint-disable-next-line vue/no-mutating-props
        this.form.reason_text = '';
      }
      if (!val.some(function (item) {
        return item === 8;
      })) {
        // eslint-disable-next-line vue/no-mutating-props
        this.form.ad_rule_text = '';
      }
    }
  },
  methods: {
    resetFields: function resetFields() {
      this.$refs.formRef.resetFields();
    },
    validate: function validate(cb) {
      return this.$refs.formRef.validate(cb);
    }
  }
};